import React from "react";
import { observer } from "mobx-react";

import { Button, Dialog } from "@material-ui/core";

import "../../styles/PopUp.scss";

import popup from '../../stores/PopupStore';

const styles = {
  popupstyle: {
    width: "100%",
  },
  popupTitle: {
    width: "100%",
  },
  iconStyle: {
    alignSelf: "center",
    marginRight: "10px",
  },
  panelStyle: {
    marginTop: "15px",
  },
};

const PopUp = observer(
  class PopUpMandatoComponent extends React.Component {
    hide = () => {
      popup.hidePopupMandato();
    };
    getTexto = () => {
      return (
        <p id="txtModal">
          Por medio del presente, autorizo a Banco Ripley a remitirse al sistema PreviRed para recolectar, almacenar y usar mis datos personales que sean necesarios para efectos de validar mi renta,
          con el objetivo de contatar y recibir los servicios relacionados a productos financieros. El tratamiento de mis datos personales se extenderá por el tiempo que dure dicha finalidad, y se
          hará conforme a la ley Nº19.628 sobre la Vida Privada.
        </p>
      );
    };

    render() {
      const texto = this.getTexto();
      return (
        <Dialog id="modal" modal="true" open={popup.popupMandato.show} style={styles.popupstyle}>
          <div className="Panel" style={styles.panelStyle}>
            <div className="titlePopup">
              <div id="txtTituloModal" style={styles.popupTitle}>
                Términos y Condiciones
              </div>
            </div>
            <div className="boxMensaje">
              <div className="mensaje">{texto}</div>
              <div className="boxButton">
                <Button id="btnPopUp" variant="contained" color="primary" onClick={this.hide} className="btn-moradoModal" fullWidth={true}>
                  aceptar
                </Button>
              </div>
            </div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      );
    }
  }
);

export default PopUp;
